import type { GlyphName } from '@neptune/shared/core-glyphs-domain';

import { AttributeType } from './attribute-model';

const attributeIcons: Partial<Record<AttributeType, GlyphName>> = {
  bool: 'bool',
  datetime: 'datetime',
  evaluationSeries: 'scatterplot',
  float: 'float',
  floatSeries: 'float-series',
  histogramSeries: 'histogram',
  fileSet: 'file-set',
  fileSeries: 'file-series',
  imageSeries: 'file-series',
  int: 'integer',
  string: 'string',
  stringSeries: 'string-series',
  stringSet: 'string-set',
  file: 'file',
  gitRef: 'git',
  experimentState: 'status',
};

const predefinedAttributeIcons: Partial<Record<AttributeType, GlyphName>> = {
  floatSeries: 'curved-dots',
  datetime: 'datetime',
};

export const getAttributeGlyphName = (attribute: AttributeType): GlyphName => {
  return attributeIcons[attribute] || 'circle';
};

export const getPredefinedAttributeGlyphName = (attribute: AttributeType): GlyphName => {
  return predefinedAttributeIcons[attribute] || 'circle';
};
